module.exports = __webpack_public_path__ + "img/chang-tien-wei-9.68497529.jpg";